import { Swiper, SwiperSlide } from 'swiper/react';
import { Thumbs, Autoplay, Navigation, Pagination, Swiper as RealSwiper } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../css/Ship.css"
import { Helmet } from 'react-helmet';

RealSwiper.use([Autoplay]);
RealSwiper.use([Thumbs]);

export const Ship = () => {
  return (
    <div style={{ "padding": "5%" }}>
      <Helmet>
        <title>船の紹介|有明海・大牟田市三池港発釣り船 【シーラインⅢ】</title>
        <meta name="description" content="シーラインⅢは、有明海での釣りを楽しむためのスーパー遊漁船です。冷暖房完備の休憩室やライフジャケットレンタルなど、快適な釣り体験をお届けします。" />
        <meta name="keywords" content="有明海 釣り船, 遊漁船,シーラインⅢ 船" />
        <meta property="og:url" content="https://sealine3-new.web.app/Ship" />
        <link rel="canonical" href="https://sealine3-new.web.app/Ship" />
      </Helmet>
      <h1 className="obi3">船の紹介</h1>
      <div style={{ 'marginTop': '10px' }}>
        <Swiper
          autoplay={{
            reverseDirection: false,
            delay: 4000,
            disableOnInteraction: false
          }}
          loop={true}
          initialSlide={7}
          navigation={true}
          pagination={{
            clickable: true,
          }}
          modules={[Navigation, Pagination]}>

          <SwiperSlide className="swiper-slide" >
            <a href=".\images\IMG1.webp" data-lightbox="group"><img alt="シーライン" src=".\images\IMG1.webp"></img></a>
          </SwiperSlide>
          <SwiperSlide className="swiper-slide">
            <a href=".\images\IMG2.webp" data-lightbox="group"><img alt="シーライン2" src=".\images\IMG2.webp"></img></a>
          </SwiperSlide>
          <SwiperSlide className="swiper-slide">
            <a href=".\images\IMG3.webp" data-lightbox="group"><img alt="運転席" src=".\images\IMG3.webp"></img></a>
          </SwiperSlide>
          <SwiperSlide className="swiper-slide">
            <a href=".\images\IMG4.webp" data-lightbox="group"><img alt="運転席2" src=".\images\IMG4.webp"></img></a>
          </SwiperSlide>
          <SwiperSlide className="swiper-slide">
            <a href=".\images\IMG5.webp" data-lightbox="group"><img alt="ベンチソファー" src=".\images\IMG5.webp"></img></a>
          </SwiperSlide>
          <SwiperSlide className="swiper-slide">
            <a href=".\images\IMG6.webp" data-lightbox="group"><img alt="トイレ" src=".\images\IMG6.webp"></img></a>
          </SwiperSlide>
          <SwiperSlide className="swiper-slide">
            <a href=".\images\IMG7.webp" data-lightbox="group"><img alt="休憩室" src=".\images\IMG7.webp"></img></a>
          </SwiperSlide>
        </Swiper>
        <ul style={{ "fontSize": "15px" }}>
          <li>定員:14名(釣り12名)</li>
          <li>冷暖房設備あり</li>
          <li>休憩室あり</li>
          <li>ライフジャケットレンタルあり</li>
        </ul>
        <div className="list-container">
          <div className="list-container-figure">
            <figure><img src="./images/IMG1.webp" alt="シーライン" /></figure>
            <h4>スーパー遊漁船</h4>
          </div>

          <div className="list-container-figure">
            <figure><img src="./images/IMG2.webp" alt="シーライン2" /></figure>
            <h4>前方より</h4>
          </div>

          <div className="list-container-figure">
            <figure><img src="./images/IMG3.webp" alt="運転席" /></figure>
            <h4>運転席より</h4>
          </div>

          <div className="list-container-figure">
            <figure><img src="./images/IMG4.webp" alt="運転席2" /></figure>
            <h4>運転席より</h4>
          </div>

          <div className="list-container-figure">
            <figure><img src="./images/IMG5.webp" alt="ベンチソファー" /></figure>
            <h4>ベンチソファー</h4>
          </div>

          <div className="list-container-figure">
            <figure><img src="./images/IMG6.webp" alt="トイレ" /></figure>
            <h4>トイレ</h4>
          </div>

          <div className="list-container-figure">
            <figure><img src="./images/IMG7.webp" alt="休憩室" /></figure>
            <h4>休憩室1</h4>
          </div>

          <div className="list-container-figure">
            <figure><img src="./images/IMG8.webp" alt="休憩室2" /></figure>
            <h4>休憩室2</h4>
          </div>
        </div>

      </div>
    </div>
  );
};


